import {BettingSvc} from '../services/betting.service';

/**
 * Random system bet validator
 * @module directives/future bet validator
 * @type {{update: (function(*, *))}}
 */

export const RandomSystemValidator = {
    update(element, binding){

        if (/[\d\.]+/i.test(element.value)) {

            let newValue = element.value ;

            if(element.value > BettingSvc.getBettingSvc().maxSystemNumber){
                newValue = '';
                BettingSvc.getBettingSvc().random = '';
            }

            element.value = newValue;
            binding.value = element.value;

        } else {

            let newValue = element.value.replace(/[a-zA-Z]+/ig, '');
            element.value = newValue;
            binding.value = element.value;
        }
    },
};


// WEBPACK FOOTER //
// randomsystem_validator.js